// import Child from "./Child";
import Teachr from "./Teachr";
declare class PunctualCourse {}

declare class Address {}

export default class Client {
  readonly "@id"?: string;
  readonly "@type"?: string;
  readonly "@context"?: string;

  firebaseAuthToken: string;
  firstName: string;
  lastName: string;
  phone: string;
  acceptMarketing: boolean;
  isNotify?: boolean;
  mail?: string;
  firebaseMessagingToken: string;
  isPremium: boolean;
  isParent: boolean;
  sex?: string; // MAN or WOMAN
  class?: number;
  birthday?: Date;
  recommendedBy?: String[] | null; // Add null to the type
  /** Champ commun prof / client côté backend : "Comment avez-vous entendu parler de nous ?" */
  recommandedBy?: string;
  sponsorship?: string | number | null; // Add null to the type
  favoriteTeachrs?: Teachr[];
  otherInformation?: string;
  profilePicture?: string; // @id for Image class
  marriedName?: string;

  URSSAFPseudoSIRET?: string;
  URSSAFNumber?: string;

  promoCode?: String;
  isRegisteredByTeachr?: boolean;
  isRelationTeachr?: boolean;

  // addresses: Address[];
  addresses: Address[];

  punctualCourses: PunctualCourse[];

  id?: number;
  lastModificationDatetime?: Date;
  creationDatetime?: Date;
  idClientTiersPrestation?: string;
  brand?:string
  //readonly children: Child[];

  // TODO see how to handle profilePicture
  referanceTeachr?: string;
  constructor(
    firebaseAuthToken: string,
    firstName: string,
    lastName: string,
    phone: string,
    acceptMarketing: boolean,
    firebaseMessagingToken: string,
    isParent: boolean,
    isPremium: boolean,
    recommendedBy?: [],

    // class_: number | undefined = undefined
  ) {
    this.firebaseAuthToken = firebaseAuthToken;
    this.firstName = firstName;
    this.lastName = lastName;
    this.phone = phone;
    this.acceptMarketing = acceptMarketing;
    this.firebaseMessagingToken = firebaseMessagingToken;
    this.isParent = isParent;
    this.isPremium = isPremium;
    // this.class = class_;

    this.addresses = [];
    this.punctualCourses = [];
    this.favoriteTeachrs = [];
    this.recommendedBy = recommendedBy;
  }
}
